function selectNextSibling(actions, query, id) {
  // If query and actions are not available, return
  if (!query || !actions) {
    return;
  }

  // Get the currently selected node
  id = id ?? query.getEvent("selected").first();

  if (!id) return; // If no node is selected, return

  // Get the parent of the currently selected node
  const parents = query.node(id).ancestors();
  if (!parents || parents.length === 0) {
    return;
  }
  const parent = parents[0];

  // Get the childrens of the parent of the currently selected node
  const children = query.node(parent).childNodes();
  if (!children || children.length === 0) {
    return;
  }

  // Get the index of the currently selected node
  const index = children.indexOf(id);

  const nextSibling = children[index + 1];

  if (!nextSibling) {
    return;
  }

  actions.selectNode(nextSibling);
}

export default selectNextSibling;
